import axios from 'axios'
import type {
	SupportSubmissionPayload,
	SupportSubmissionResponse,
} from '../../shared/types/support'

export async function submitSupportSubmission(
	payload: SupportSubmissionPayload,
): Promise<SupportSubmissionResponse> {
	const res = await axios.post<SupportSubmissionResponse>(
		'/api/support',
		payload,
	)
	return res.data
}
